import { buildApiUrl} from './apiConfig';
import { post, get } from '../utils/baseRequest';

export const createPrompt = async (promptData) => {
  try {
    const response = await post(buildApiUrl(`/v1/prompt/create`), promptData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getPromptById = async ({ id, tenantId }) => {
  const url = buildApiUrl(`/v1/prompt/${id}?tenantId=${tenantId}`);
  try {
    const response = await get(url);
    return response;          
  } catch (err) {
    console.error('Error fetching prompt by id:', err);
    throw err;                
  }
};

export const listPrompts = async ({ tenantId, page = 1, pageSize = 6 }) => {
  const body = { tenantId, page, pageSize };
  const response = await post(buildApiUrl(`/v1/prompt/list`), body);
  return response; 
};
